import L from 'leaflet'

export class Restercoods {
  map: any
  width: number
  height: number
  tilesize: number
  zoom: number
  
  constructor(map: any, imgsize: [number, number], tilesize?: number) {
    this.map = map
    this.width = imgsize[0]
    this.height = imgsize[1]
    this.tilesize = tilesize || 256
    this.zoom = this.zoomLevel()
  }
  zoomLevel() {
    return Math.ceil(Math.log(Math.max(this.width, this.height) / this.tilesize) / Math.log(2))
  }
  // Convert X,Y to lat,lng
  unproject(coords: any) {
    return this.map.unproject(coords, this.zoom)
  }
  // Convert lat,lng to X,Y
  project(coords: any) {
    return this.map.project(coords, this.zoom)
  }
  getMaxBounds() {
    const southWest = this.unproject([0, this.height])
    const northEast = this.unproject([this.width, 0])
    return new L.LatLngBounds(southWest, northEast)
  }
  setMaxBounds(): void {
    const bounds = this.getMaxBounds()
    this.map.setMaxBounds(bounds)
  }
}
